<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa Thiết bị</h1>
      <div class="btn-group float-right">
        <button type="button" class="btn font-medium btn-outline-secondary" @click="updateLead()">
          <i class="bx bx-save"></i> Lưu
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="leadsEdit" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <h1 class="form-inner-heading mb-1">Thông tin</h1>

          <ValidationProvider rules="required|minMaxName_2" vid="merchantName" name="Tên thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Tên thiết bị <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.merchantName"
                  type="text"
                  class="form-control"
                  placeholder="Tên thiết bị"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_2" vid="customerName" name="Mã Serial">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Mã Serial <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.customerName"
                  type="text"
                  class="form-control"
                  placeholder="Mã Serial"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="cityCode" name="Mã thùng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Mã thùng <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.cityCode"
                  :options="dataProvince"
                  @change="getDistictByCode($event)"
                  @select="getNameProvince($event)"
                  placeholder="Mã thùng"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="rating" name="Tình trạng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Tình trạng<span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2 v-model="dataAdd.rating" :options="dataRating" placeholder="Tình trạng" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú</label>
            <div class="col-sm-7">
              <input
                v-model="dataAdd.description"
                type="text"
                class="form-control"
                placeholder="Ghi chú"
              />
            </div>
          </div>
        </form>

        <form class="col-md-6"></form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LeadsService } from '@/services/lead.service'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import { StaffService } from '@/services/staff.service'
  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        dataAdd: {
          uploadImages: [],
        },
        leadId: this.$route.params.leadId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },
        messSuccess: '',
        messErr: '',
        dataContractOrigin: [],
        dataProvince: [],
        dataDistrict: [],
        showModalAddImage: false,
        dataUploadImage: [],
        dataConfigMcc: [],
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',

        dataRating: [
          { id: 'HOT', text: 'Ưu tiên' },
          { id: 'WARM', text: 'Thường' },
          { id: 'COLD', text: 'Không ưu tiên' },
        ],
      }
    },

    mixins: [prepareQueryParamsMixin],

    created() {
      this.getProvince()
      this.configSystem()
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closeAdd() {
        this.$router.push('/device')
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigMcc = [{ id: '0', text: '-- -- --' }]
              data.data.businessFields.map(e => {
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              })
            }
          })
          .catch(error => console.log(error))
      },

      async fetchData() {
        try {
          const response = await LeadsService.detailLead({
            leadId: this.leadId,
          })
          if (response.code === 1000 || response.success) {
            this.dataAdd = response.data
            await this.getDistictByCode(this.dataAdd.cityCode)
            this.dataUploadImage = this.dataAdd.uploadImages.length ? this.dataAdd.uploadImages : []
          }
        } catch (error) {
          console.log(error)
        }
      },

      async updateLead(isAllow) {
        try {
          const serviceList = []
          if (this.dataAdd.suggestServiceList && this.dataAdd.suggestServiceList.length) {
            this.dataAdd.suggestServiceList.map(e => {
              if (e.serviceType && e.serviceType !== null) serviceList.push(e.serviceType)
              else delete this.dataAdd.suggestServiceList
            })
          }

          if (serviceList.length !== 0) this.dataAdd.suggestServiceList = serviceList

          if (isAllow) this.dataAdd.allowSave = true
          else delete this.dataAdd.allowSave

          if (this.dataAdd.districtCode === '0') {
            delete this.dataAdd.districtCode
            delete this.dataAdd.district
          }
          if (this.dataAdd.mcc === '0') delete this.dataAdd.mcc
          if (this.dataAdd.rating === '0') delete this.dataAdd.rating

          const isSuccess = await this.$refs.leadsEdit.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          const response = await LeadsService.updateLead(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = 'Cập nhật Lead thành công !'
            this.keyCheck = 'accept'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else if (response.code === 1025 || response.code === 1039 || response.code === 1042) {
            this.keyCheck = 'addLead'
            this.showErr(response.message)
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      async getProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            data.data.filter(e => {
              this.dataUser.adminLocations.forEach(element => {
                if (e.code === element) {
                  this.dataProvince.push({
                    id: e.code,
                    text: e.name,
                  })
                }
              })
            })
            return
          }
          this.dataProvince = []
        } catch (error) {
          console.log(error)
        }
      },

      async getDistictByCode(code) {
        try {
          this.dataDistrict = []
          const data = await StaffService.getDistictByCode({ cityCode: code })
          if (data.data.length > 0) {
            const dataDistrict = [{ id: '0', text: '-- -- --' }]
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistrict = dataDistrict
          }
        } catch (error) {}
      },

      getNameProvince(item) {
        this.dataAdd.city = item.text
      },
      getNameDistrict(item) {
        this.dataAdd.district = item.text
      },

      showAddImages() {
        this.showModalAddImage = true
      },
      closeAddImages() {
        this.showModalAddImage = false
        this.dataAdd.uploadImages = this.dataUploadImage
      },
      addLeadImages(dataImages) {
        this.dataAdd.uploadImages = this.dataUploadImage = dataImages
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.updateLead(true)
        }
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
</style>
